import { ReactNode } from "react";
import {
  Slide,
  toast,
  ToastContainer,
  ToastContainerProps,
} from "react-toastify";

interface ToastProps extends ToastContainerProps {
  children?: ReactNode;
}

export const Toastify = (props: ToastProps) => (
  <ToastContainer
    position="bottom-center"
    hideProgressBar
    theme="colored"
    transition={Slide}
    autoClose={false}
    draggablePercent={60}
    {...props}
  />
);
